export default "__VITE_ASSET__B_J2cr7t__"